import { groupBy } from 'lodash';
import { AccordionWidgetData, FundamentalsMetrics } from '../../../models/RiskProducts';

export const getFundamentalsData = (metrics: FundamentalsMetrics | undefined): AccordionWidgetData[] => {
  if (!metrics || !metrics.display_attributes) {
    return [];
  }

  const grouped = groupBy(metrics.display_attributes, (metric) => metric.group);
  return Object.entries(grouped).map(([group, items]) => {
    return {
      item: { label: group, value: null },
      children: items.map((item) => {
        return { label: item.label, value: item.value };
      }),
    };
  });
};
